import { SpacesServiceClient } from '@playq/octopus2-apps';

import { transport } from '../core';

export const spacesService = new SpacesServiceClient(transport);
